import { AddonAddWishData } from '@/components/addons/addwish/Data';
import AddonModel from '@/models/grid/AddonModel';
import { AddonModelState } from '@/typings/interfaces/state/Addon';

export interface ExtraDataList {
  categoryList: string[];
  filterSizeList: string[];
}

export interface ExtraData {
  itemNumber: string;
  isBag: string;
  gender: string;
  filterForing: string;
  filterMateriale: string;
  isNew: string;
  filterColor: string;
  filterSkospids: string;
  filterBredde: string;
  filterLukning: string;
  filterLenght: string;
  filterWeight: string;
  filterSizevariant: string;
  filterHeeltype: string;
  isOnSale: string;
  filterSaal: string;
}

export interface Product {
  url: string;
  imageUrl: string;
  title: string;
  priceLowered: boolean;
  onSale: boolean;
  price: number;
  priceFormatted: string;
  priceExVatFormatted: string;
  previousPrice: number;
  previousPriceFormatted: string;
  shopPreviousPrice: number;
  shopPreviousPriceFormatted: string;
  oldPriceExVatFormatted: string;
  oldPrice: number;
  oldPriceFormatted: string;
  currency: string;
  category: string;
  brand: string;
  productNumber: string;
  extraDataList: ExtraDataList;
  extraData: ExtraData;
}

interface AddonAddWishState extends AddonModelState {
  alias: string;
  apiKey?: string;
  products: Product[];
  addonValid: boolean;
}

export class AddonAddWishModel extends AddonModel<AddonAddWishData, AddonAddWishState> {
  parseAddon(data: AddonAddWishData): void {
    const state = this.state;
    if (data.settings.api_key) {
      state.apiKey = data.settings.api_key;
    } else {
      state.apiKey = undefined;
    }
    state.products = data.settings.products ?? [];
  }

  public isAddonValid(): boolean {
    const data = this.getData();
    return !(!data.settings.api_key || (data.settings?.products && data.settings.products.length === 0));
  }

  authorSignature(): string {
    return 'Nicky Christensen';
  }
}
